<jhi-alert-overlay />
<div
    id="page-wrapper"
    class="page-wrapper"
    [ngClass]="{ 'no-padding': isShownViaLti() }"
    [style.overflow-y]="!isTestRunExam() && isExamStarted() ? 'hidden' : 'auto'"
    cdkScrollable
>
    @if (showPageRibbon()) {
        <jhi-page-ribbon />
    }
    @if (showSkeleton() && !isShownViaLti()) {
        <div class="sticky-top-navbar">
            <router-outlet name="navbar" />
        </div>
    }
    @if (showSkeleton()) {
        <div>
            <div [ngClass]="{ 'module-bg page-content-card p-3 rounded rounded-3': usesModuleBackground() }">
                <router-outlet />
            </div>
        </div>
    } @else {
        <router-outlet />
    }
    <jhi-course-notification-popup-overlay />
    <jhi-llm-selection-modal />
    <jhi-setup-passkey-modal />
    @if (showSkeleton() && !isShownViaLti()) {
        @if (isTestRunExam() || !isExamStarted()) {
            <jhi-footer />
        }
    }
    <!-- Global Search Modal -->
    @if (globalSearchEnabled() && showSkeleton() && !isShownViaLti() && (!isExamStarted() || isTestRunExam())) {
        <jhi-global-search-modal />
    }
</div>
